// extracted by mini-css-extract-plugin
export default {"toggle":"sK2k6wjQkzgeAae85gWQ","expandable":"C8s0L2MN6srnhFkXVStj","icon":"OIv8qwCDPafVjgw1lLIS","heading":"v3VS9VtAoixIsyTX_lFk"};